'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propertiesMap = undefined;
exports.addOfferToVacationRental = addOfferToVacationRental;
exports.createVacationRental = createVacationRental;

var _helpers = require('../helpers');

var _config = require('../config');

var _Offer = require('./Offer');

var _rating = require('../helpers/rating');

var _modelHelper = require('../helpers/model-helper');

var _constants = require('../constants');

var propertiesMap = {
  adjective: function adjective(_ref) {
    var combined_rating = _ref.combined_rating;
    return (0, _modelHelper.getAdjective)(combined_rating);
  },
  availability: null,
  cancellationPolicy: null,
  category: 'category_id',
  categoryLiteral: function categoryLiteral(item) {
    return _constants.CATEGORY_LITERALS[item.category_id];
  },
  cheapestPartner: 'partner_id',
  combinedRating: function combinedRating(item) {
    return item.combined_rating ? Math.round(item.combined_rating * 10) / 10 : 0;
  },
  discount: null,
  features: 'features',
  id: 'id',
  images: 'images',
  latitude: 'latitude',
  longitude: 'longitude',
  maxDayPrice: null,
  maxGuests: 'max_guests',
  maxTotalPrice: null,
  minDayPrice: null,
  minTotalPrice: null,
  numberOfComments: null,
  numImages: 'num_images',
  partners: function partners(item) {
    return (0, _modelHelper.parsePartners)(item, _Offer.createOfferFromMatchingPublications);
  },
  polygons: 'polygons',
  qualityScore: null,
  rating: function rating(item) {
    return item.rating ? Math.round(item.rating) : 0;
  },
  recommendation: null,
  revenue: function revenue(_ref2) {
    var _revenue = _ref2.revenue;
    return (0, _modelHelper.getItemRevenue)(_revenue);
  },
  rooms: 'num_rooms',
  titlePreposition: function titlePreposition(_ref3) {
    var title_preposition = _ref3.title_preposition;
    return getTitlePreposition(title_preposition);
  }
};

exports.propertiesMap = propertiesMap;
function getTitlePreposition(prepositions) {
  if (!prepositions || typeof prepositions === 'string') return null;
  var domainCulture = (0, _config.getConfig)('DOMAIN_CULTURE');
  return prepositions[domainCulture] || prepositions[_constants.CULTURE_FALLBACK[domainCulture]] || null;
}

function addOfferToVacationRental(publication, estb, dateArrival, numberOfDays) {
  var pIndex = estb.partners.findIndex(function (partnr) {
    return partnr.partner_id === publication.partner_id;
  });

  if (pIndex >= 0) Object.assign(estb.partners[pIndex], (0, _Offer.createOffer)(publication, dateArrival, numberOfDays));else estb.partners.push((0, _Offer.createOffer)(publication, dateArrival, numberOfDays));

  return updateVacationRental(estb);
}

function updateVacationRental(vacationRental) {
  return (0, _rating.calculateRating)((0, _modelHelper.calculatePrices)(vacationRental));
}

function createVacationRental(publication) {
  if (typeof publication === 'undefined') return false;

  var mapPub = (0, _helpers.definePropertiesMap)(propertiesMap);
  var parsedVacationRental = mapPub(publication);
  return updateVacationRental(parsedVacationRental);
}